var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranslate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 3,
    x1: 307.01,
    y1: 499.5,
    x2: 308.65,
    y2: 536.53,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.1865 0 0-1.02616-323 544.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1360c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2190ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 4,
    x1: 47.83,
    y1: 21.32,
    x2: 46.836,
    y2: 3.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cdd6da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f7f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 2,
    x1: 59.22,
    y1: 37.13,
    x2: 67.54,
    y2: 34.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1e48aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e2a8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 0,
    x1: 70.21,
    y1: 30.867,
    x2: 69.59,
    y2: 14.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1f52b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147bdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 1,
    x1: 331.2,
    y1: 531.93,
    x2: 330.68,
    y2: 493.75,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.3571 0 0-1.03373-382.32 554.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcebe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f8f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99999 0 0 .99999-33.481 5.512)",
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.909 42.37l-13.233-38.976h28.755c5.383-.219 5.997 3.562 5.997 3.562v31.16c0 0 .943 4.254-4.758 4.254z",
    fill: "url(#1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.54 18.732h9.709c-.274 1.753-1.203 3.621-2.766 5.555-.996-1.595-1.636-3.143-2-4.173-.092-.26-.338-.434-.614-.434h-1.598c-.208 0-.403.099-.526.267-.123.168-.158.383-.095.582.379 1.192 1.25 3.532 2.862 5.91-1.904 1.851-3.801 3.185-4.535 3.677-.292.196-.376.588-.189.886l.802 1.282c.093.148.242.253.413.291.046.001.093.015.139.015.126 0 .251-.037.358-.107.756-.497 2.716-1.852 4.769-3.819.76.792 2.545 2.179 3.603 2.949.161.117.368.154.561.1.192-.055.349-.195.425-.38l.598-1.462c.12-.294.011-.632-.259-.799-.689-.428-1.987-1.306-3.047-2.447 2.326-2.722 3.652-5.376 3.944-7.891h.513c.359 0 .651-.292.651-.651v-1.735c0-.359-.291-.651-.651-.651h-5.07v-.891c0-.36-.291-.651-.651-.651h-1.624c-.359 0-.651.291-.651.651v.891h-5.07c-.359 0-.651.291-.651.651v1.735c0 .359.291.65.651.65",
    fill: "url(#0)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.2 32.935l3.562 9.516 8.535-9.516z",
    fill: "url(#2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.32-5.47l12.985 38.69h-30.05c-4.707.218-4.769-3.536-4.769-3.536v-30.932c0 0 .125-4.223 5.109-4.223z",
    fill: "url(#3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m50.27 5.455c-.097-.312-.386-.525-.713-.525h-4.145c-.328 0-.617.214-.713.528l-4.953 16.194c-.069.226-.027.472.114.663.141.19.363.302.6.302h2.571c.335 0 .629-.224.719-.546l1.11-3.995h5.067l1.202 4.01c.094.316.385.532.715.532h2.733c.238 0 .46-.113.6-.303.141-.191.182-.437.112-.664l-5.02-16.195m-4.836 9.633l1.866-7.164h.051l1.996 7.164h-3.913z",
    fill: "url(#4)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/Translate.3b56c9c5cc3f3e82058e4a4d6ac985d0.svg";
export { ForwardRef as ReactComponent };